const formatMarkdown = markdown =>
  // Use regex with replace to insert \r\n\r\n before <, but only if \r\n\r\n isn't already there
  markdown.replace(/(?:(?:\r\n){2}(?!.*(?:(?:\r\n){2})))?(<)/g, '\r\n\r\n$1');

export default formatMarkdown;
